<script lang="ts" setup>
// @ts-ignore
import { TrackerDataType } from '@scr-npm/nuxt-tracker/dist/runtime/types'

const { data: wizard } = useLazyFetch<WizardReponseData>(
    '/api/wizard/contact-us'
)

const wizardModalData = ref<WizardData | null>()

const attrs = useAttrs()
</script>
<template>
  <section
    v-if="wizard"
    v-bind="attrs"
  >
    <Box
      color="purple"
    >
      <Tracker :data="{ position: wizard?.title || '' } as TrackerDataType">
        <BoxHeader
          heading-level="h2"
          :heading="wizard.title"
        />
        <div class="row g-6">
          <div
            v-for="(item, index) in wizard.data"
            :key="`weus-${index}`"
            class="col-12 col-md-6 col-lg-4"
          >
            <WidgetEmailUsItem
              :item="item"
              @select="(data: WizardData) => wizardModalData = data"
            />
          </div>
        </div>
      </Tracker>
    </Box>
  </section>

  <Tracker :data="{ position: wizard?.title || '' } as TrackerDataType">
    <Modal
      v-if="wizardModalData"
      :is-open="Boolean(wizardModalData)"
      size="xxl"
      @close="wizardModalData = null"
    >
      <WidgetWizard :data="wizardModalData" />
    </Modal>
  </Tracker>
</template>
